




































































































































































































































































































































































































































































































































































































































































import { Component, Vue } from 'vue-property-decorator';
import PersonSearch from "@/components/common/PersonSearch.vue";
import PortalDate from "@/components/common/PortalDate.vue";
import SingleFileHolder from "@/components/util/SingleFileHolder.vue";
import PortalInput from "@/components/common/PortalInput.vue";
import PortalCollapse from "@/components/request/w9cr/PortalCollapse.vue";
import {PersonSex, ResidencyStatus, SSNType, StateIDSubtype} from "@/constants/PersonConstants";
import {PublicRIDCContractorDTO} from "@/dto/request/ridc/PublicRIDCContractorDTO";
import PersonDTO from "@/dto/person/PersonDTO";
import { namespace } from "vuex-class";
import PortalAddress from "@/components/profile/branches/PortalAddress.vue";
import PortalCheckbox from "@/components/common/PortalCheckbox.vue";
import {
  BankAccountData,
  CitizenPassportDataDTO,
  EADDataDTO, ForeignPassportDataDTO,
  GreenCardDataDTO,
  SSNCardDataDTO,
  StateIDDataDTO
} from "@/dto/request/rer/CompleteREREmployeePayload";
import RIDCService from "@/services/request/RIDCService";
import { RIDCContractorStatus } from "@/constants/request/RIDCConstants";
import CompleteRIDCContractorPayload from "@/dto/request/ridc/CompleteRIDCContractorPayload";
import { ifValid, processError } from "@/utils/ComponentUtils";
import AutoComplete from "@/components/common/AutoComplete.vue";
import AutoCompleteDTO from "@/components/common/AutoCompleteDTO";
import { ContractorFilter } from "@/dto/payroll/Filters";
import { EmploymentStatus, IContractor } from "@/components/payroll/business/employments/contractors/Contractor";
import ContractorService from "@/components/payroll/business/employments/contractors/ContractorService";

const AppModule = namespace("App");

@Component({
  computed: {
    AutoCompleteDTO() {
      return AutoCompleteDTO
    },
    SSNType() {
      return SSNType
    },
    StateIDSubtype() {
      return StateIDSubtype
    },
    PersonSex() {
      return PersonSex
    },
    ResidencyStatus() {
      return ResidencyStatus
    },
    RIDCContractorStatus() {
      return RIDCContractorStatus
    },
  },
  components: {
    AutoComplete,
    PortalCheckbox,
    PortalAddress,
    PortalCollapse,
    PortalInput,
    SingleFileHolder,
    PortalDate,
    PersonSearch
  }
})
export default class ContractorRIDC extends Vue {

  @AppModule.Action
  private startLoading!: () => void

  @AppModule.Action
  private stopLoading!: () => void

  contractor = new PublicRIDCContractorDTO();
  payload = new CompleteRIDCContractorPayload();
  createPerson = false;
  selectedPerson: PersonDTO | null = null;
  foundContractors: Array<IContractor> = [];
  selectedContractor: IContractor | null = null;
  hasNoHireDate = false;

  mounted(): void {
    this.initPayload();
  }

  initPayload(): void {
    this.startLoading();
    RIDCService.getFullInformationContractor(this.id).then(ok => {
        this.contractor = ok.data;
        this.stopLoading();
      },
      err => {
        this.stopLoading();
        processError(err, this);
      }).then(() => {
      this.payload.id = this.contractor.id;
      this.payload.residencyStatus = this.contractor.residencyStatus;
      this.payload.contractStart = this.contractor.contractStart;
      switch (this.contractor.residencyStatus!) {
        case ResidencyStatus.CITIZEN:
          if (this.contractor.citizenPassportRequired && this.contractor.citizenPassportImage) {
            this.payload.passport = new CitizenPassportDataDTO();
            this.payload.passport.file = this.contractor.citizenPassportImage;
          }
          break;
        case ResidencyStatus.PERMANENT_RESIDENT:
          if (this.contractor.greenCardRequired) {
            this.payload.greenCard = new GreenCardDataDTO();
            this.payload.greenCard.front = this.contractor.greenCardFrontImage;
            this.payload.greenCard.back = this.contractor.greenCardBackImage;
          }
          break;
        case ResidencyStatus.NON_CITIZEN:
          if (this.contractor.eadRequired) {
            this.payload.ead = new EADDataDTO();
            this.payload.ead.front = this.contractor.eadFrontImage;
            this.payload.ead.back = this.contractor.eadBackImage;
          }
          break;
      }
      if (this.contractor.ssnRequired) {
        this.payload.ssn = new SSNCardDataDTO();
        this.payload.ssn.file = this.contractor.ssnImage;
      }
      if (this.contractor.stateIdRequired && !this.contractor.stateIdIsValid) {
        if (!this.contractor.foreignPassportTitleImage) {
          this.payload.stateID = new StateIDDataDTO();
          this.payload.stateID.front = this.contractor.stateIdFrontImage;
          this.payload.stateID.back = this.contractor.stateIdBackImage;
        } else {
          this.payload.foreignPassport = new ForeignPassportDataDTO();
          this.payload.foreignPassport.title = this.contractor.foreignPassportTitleImage;
        }
      }
      if (this.contractor.bankDetailsRequired && !this.contractor.currentAccountIsValid) {
        this.payload.bankAccount = new BankAccountData();
      }
      this.hasNoHireDate = !this.payload.contractStart;
    });
  }

  onPersonSelected(person: PersonDTO): void {
    this.startLoading();
    this.payload.personId = person.id;
    this.payload.firstName = person.firstName;
    this.payload.lastName = person.lastName;
    if (this.contractor.ssnRequired && this.payload.ssn) {
      this.payload.ssn.ssn = person.ssn;
    }
    const filter = new ContractorFilter();
    filter.status = [EmploymentStatus.NEW, EmploymentStatus.ACTIVE, EmploymentStatus.PENDING_FOR_DOCUMENTS]
    filter.detailsId = person.id;
    ContractorService.getAllByFilter(filter).then(
      ok => {
        this.foundContractors = ok.data.data.filter(e => e.employer?.id == this.contractor.companyId);
        if (this.foundContractors.length == 1) {
          this.selectedContractor = this.foundContractors[0];
          this.payload.contractorId = this.selectedContractor.id;
        }
        this.stopLoading();
      },
      err => {
        processError(err, this);
        this.stopLoading();
      }
    )
  }

  save(): void {
    ifValid(this, () => {
      this.startLoading();
      RIDCService.completeContractorRegistration(String(this.contractor.id), this.payload).then(
        ok => {
          this.contractor.status = RIDCContractorStatus.COMPLETED;
          this.stopLoading();
          location.reload();
        },
        err => {
          processError(err, this);
          this.stopLoading();
        }
      )
    })
  }

  continueWithoutBankDetails(): void {
    this.startLoading();
    RIDCService.skipUploadingStage(this.id).then(
      ok => {
        this.startLoading();
        location.reload();
      },
      err => {
        processError(err, this);
        this.stopLoading();}
    )
  }

  contractorChanged(): void {
    if (this.selectedContractor) {
      this.payload.contractorId = this.selectedContractor.id;
    } else {
      this.payload.contractorId = null;
    }
  }

  get id(): number {
    return Number.parseInt(this.$route.params.id);
  }

  get statusTitle(): string {
    switch (this.contractor!.status) {
      case RIDCContractorStatus.SENT:
        return "Sent"
      case RIDCContractorStatus.OPENED:
        return "Opened"
      case RIDCContractorStatus.DOCUMENTS_PARTIALLY_UPLOADED:
        return "Documents have been partially uploaded"
      case RIDCContractorStatus.ALL_DOCUMENTS_UPLOADED:
        return "All documents have been uploaded"
      case RIDCContractorStatus.W9_BEING_SIGNED:
        return "W-9 is being signed by contractor"
      case RIDCContractorStatus.COMPLETED:
        return "Completed"
      default:
        return this.contractor.status as string;
    }
  }

  get residencyStatusTitle(): string {
    switch (this.contractor!.residencyStatus) {
      case ResidencyStatus.CITIZEN:
        return "A citizen of the United States"
      case ResidencyStatus.PERMANENT_RESIDENT:
        return "A lawful permanent resident"
      case ResidencyStatus.NON_CITIZEN:
        return "A noncitizen"
      default:
        return `${this.contractor.residencyStatus}`;
    }
  }

  get isAllButVoidCheckUploaded(): boolean {
    return this.isFederalUploaded && this.isStateIdUploaded && this.isSSNUploaded;
  }

  get isFederalUploaded(): boolean {
    switch (this.contractor?.residencyStatus) {
      case ResidencyStatus.CITIZEN: return !this.contractor.citizenPassportRequired || !!this.contractor.citizenPassportImage;
      case ResidencyStatus.PERMANENT_RESIDENT: return !this.contractor.greenCardRequired || !!this.contractor.greenCardFrontImage && !!this.contractor.greenCardBackImage;
      case ResidencyStatus.NON_CITIZEN: return !this.contractor.eadRequired || !!this.contractor.eadFrontImage && !!this.contractor.eadBackImage;
      default: return false;
    }
  }

  get isStateIdUploaded(): boolean {
    return !this.contractor.stateIdRequired
      || ((!!this.contractor.latestStateIdState && this.contractor.stateIDValid) || !!this.contractor.stateIdFrontImage);
  }

  get isSSNUploaded(): boolean {
    return !this.contractor.ssnRequired || !!this.contractor.ssnImage;
  }

}
